module.exports = {
    // for the container
    'container-gutters-mobile': '20px',
    'container-gutters-tablet': '60px',
    'container-gutters-desktop': '80px',
    'container-gutters-desktop-l': '100px',
    // for columns
    'column-gutters-mobile': '10px',
    'column-gutters-tablet': '10px',
    'column-gutters-desktop': '15px',
    'column-gutters-desktop-l': '15px',
    // for rows (negative values to fix margins on columns for first and last)
    'row-gutters-mobile': '-10px',
    'row-gutters-tablet': '-10px',
    'row-gutters-desktop': '-15px',
    'row-gutters-desktop-l': '-15px',
  }
  


// WEBPACK FOOTER //
// ./src/vars/gutters.js